<template>
    <!--右侧 升级精品游套餐-->
    <div class="o-detail order-comm" v-if="selectedShorexes.length > 0">
        <div class="order-detail">
            <div v-if="selectedShorexes[0].shorex.shorexType===1" class="title">选订常规游</div>
            <div v-else class="title">升级精品游</div>
            <div id="selectShorex">
                <div class="order-single" v-for="(selectedShorex, i) in selectedShorexes" :key="('selectedShorex_'+i)">
                    <div class="o-title">
                        <div class="sub_title">{{selectedShorex.shorex.shorexName}}</div>
                        <div class="price">${{selectedShorex.shorex.price}}/人</div>
                    </div>
                    <ul>
                        <li v-for="(booking) in selectedShorex.bookings" :key="('selectedShorex_'+i+'_booking_'+booking.bookingId)">
                            <div class="order-hao">订单号：{{booking.bookingId}}</div>
                            <div>{{getCruise(booking).cruiseName}}</div>
                            <div>{{getCruise(booking).cruiseNightDate}} {{getCruise(booking).shipName}}</div>
                            <div>{{getCruise(booking).sailDateBegin}}-{{getCruise(booking).sailDateEnd}}</div>
                            <div class="person-num">乘客人数：{{getGuestNumber(booking)}}人</div>
                        </li>
                    </ul>
                    <div class="sub-total">合计<span style="color: #ff3022">${{getBookingPrice(selectedShorex)}}</span></div>
                </div>
            </div>
        </div>
        <div class="">
            <div class="should-total">
                <span>应付总计</span>
                <span id="totalPrice" style="color: #ff3022">${{totalPrice}}</span>
            </div>
            <div class="order-btn" @click="submitShorex">
                <a>确认提交</a>
                <div v-if="selectedShorexes[0].shorex.shorexType===2">费用在登轮后自动房卡扣</div>
            </div>
        </div>
    </div>

    <!--您还没有选择精品游套餐-->
    <div class="not-choose-menu order-comm" v-else>
        <div class="order-detail">
            <div class="title">升级精品游</div>
            <div class="center-content" v-if="shorexes.length>0">您还没有选择精品游套餐</div>
            <div class="center-content" v-else>很抱歉,{{payShorexOnlyStr}}选定开放后，我们会在第一时间以短信的方式通知您，您也可以密切关注皇家加勒比官方网站。</div>
        </div>
        <div>
            <div class="order-btn click-btn oc-btn" @click="submitShorex">
                <a>确认升级</a>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import {formatYYYYMMDD, gioTracking} from "@/utilities/tools";
export default {
    name: "ShorexSummary",
    props: {
        selectedShorexes: {
            type: Array,
            default () {
                return []
            }
        },
        shorexes: {
            type: Array
        },
        payShorexOnlyStr: {
            type: String,
            default: ''
        }
    },
    methods: {
        getGuestNumber (booking) {
            const guests = booking.bookingGuests || []
            return guests.length
        },
        
        getCruise (booking) {
            return booking.cruise || {}
        },
        getBookingPrice (selectedShorex) {
            if (selectedShorex.shorex && selectedShorex.bookings) {
                let amount = 0
                selectedShorex.bookings.forEach((booking) => {
                    amount += selectedShorex.shorex.price * this.getGuestNumber(booking)
                })
                return amount
            }
            return 0
        },
        async submitShorex () {
            let submitShorex = []
            let time = formatYYYYMMDD(this.selectedShorexes[0].shorex.sailDate)
            let gioInfo = 'shorexUpsellConfirmSaildate'+time+this.selectedShorexes[0].shorex.shorexName
            gioTracking('track','evt_ButtonClicked',{'btnTypes':gioInfo})
            this.selectedShorexes.forEach((selectedShorex) => {
                if (selectedShorex.shorex && selectedShorex.bookings) {
                    selectedShorex.bookings.forEach((booking) => {
                        submitShorex.push({
                            bookingId: booking.bookingId,
                            shorexId: selectedShorex.shorex.id,
                            source:'online'
                        })
                    })
                }
            })
            if (submitShorex.length == 0) {
                this.$alert.show('请选择升级的岸上观光')
                return
            }
            const requestData = {
                viewModel: submitShorex
            }
            this.$loading.show()
            const { success, data, errMsg } = await api.booking.selectShorexV2(requestData)
            this.$loading.hide()
            if (success) {
              let tipsText = '升级成功'
              if(this.selectedShorexes[0].shorex.shorexType===1){
                tipsText = '提交成功'
              }
                this.$alert.show(tipsText, {
                    confirmCallBack: ()=> {
                      // window.open(process.env.VUE_APP_BASE_URL+'/Rccl.Booking/Booking/PaySuccessBack')
                        this.$router.push({
                            name: "PaySuccessBack",
                            query: {
                              isShowPopup: data.isShowPopup
                            }
                        })
                    }
                })
                return 
            }else{
                if (errMsg && errMsg.length > 0) {
                    this.$alert.show(errMsg)
                }
            }
            console.error(errMsg)
        }
    },
    computed: {
        totalPrice () {
          console.log('selectedShorexes',this.selectedShorexes)
            let amount = 0
            this.selectedShorexes.forEach((selectedShorex) => {
                amount += this.getBookingPrice(selectedShorex)
            })
            return amount
        }
    }
}
</script>

<style lang="less" scoped>
.order-comm {
    position: relative;
}
.order-comm.fix-top {
    position: fixed;
    top: 0;
}
.order-detail {
    width: 306px;
    border-top: 2px solid #006ab9;
    background: #fff;
    padding-left: 20px;
    padding-right: 14px;
    box-sizing: border-box;
    .title {
        font-size: 22px;
        font-weight: bold;
        color: #006ab9;
        text-align: center;
        margin: 14px 0 14px 0;
    }
    .order-single {
        position: relative;
        padding-bottom: 18px;
        color: #747d80;
        font-weight: 500;
        .o-title {
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            .sub_title {
                font-size: 20px;
                color: #282b2c;
                font-weight: bold;
            }
            .price {
                font-size: 14px;
                color: #ff3022;
                position: relative;
                top: 3px;
                font-weight: 600;
            }
        }
        li {
            border-bottom: 1px solid #d3dadd;
            margin-bottom: 12px;
            div {
                margin-bottom: 2px;
            }
            .order-hao {
                font-weight: 500;
                font-size: 14px;
                color: #282b2c;
            }
            .person-num {
                color: #747d80;
                font-weight: 500;
                padding-bottom: 7px;
            }
        }
        .sub-total {
            text-align: right;
            font-weight: bold;
            span {
                margin-left: 15px;
            }
        }
    }
    
}
.should-total {
    display: flex;
    justify-content: space-between;
    background: #e7f5ff;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    font-weight: bold;
}
.order-btn {
    width: 100%;
    height: 50px;
    text-align: center;
    //line-height: 50px;
    font-size: 18px;
    font-weight: 600;
    color: #282b2c;
    background: #ffd800;
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    a {
        color: #333;
        text-decoration: none;
    }
    div{
      font-size: 12px;
    }
}

.not-choose-menu .center-content {
    margin-top: 80px;
    text-align: center;
    font-size: 14px;
    color: #747d80;
    font-weight: 400;
    height: 150px;
}

.not-choose-menu .oc-btn {
    background: #d3dadd;
    a {
        color: #fff;
    }
}
</style>